import tinycolor from 'tinycolor2';

const black = [0, 0, 0];
const white = [255, 255, 255];

// blends two [r,g,b] values (foreground(fg) and background(bg)), with an opacity (o) applied to the foreground
const blendAlpha = (fg = white, o = 1, bg = white) => fg.map((colFg, idx) => o * colFg + (1 - o) * bg[idx]);

const shiftColor = (color, bg = white, amount = 100) => {
  const opacity = amount / 100;
  let { r, g, b } = tinycolor(color).toRgb();
  [r, g, b] = blendAlpha(bg, opacity, [r, g, b]);
  return tinycolor({ r, g, b }).toHexString();
};

export const darkenLess = color => shiftColor(color, black, 10);

export const lightenMore = color => shiftColor(color, white, 78);
